import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MenuInfo } from '../models/menu-info';
import { PageTitleInfo } from '../models/page-title-info';

/**
 * 外框版面控制服務
 *
 * @export
 * @class LayoutService
 */
@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  /**
   * 資訊檢視模式
   */
  viewMode$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   * 頁面名稱
   */
  pageTitle$ = new BehaviorSubject<PageTitleInfo>({});

  /**
   * 麵包屑
   */
  breadCrumbs$ = new BehaviorSubject<MenuInfo[]>([]);

  constructor() { }

  getViewModeObservable(): Observable<boolean> {
    return this.viewMode$.asObservable();
  }

  setViewMode(value: boolean): void {
    this.viewMode$.next(value);
  }
}
